import { render, staticRenderFns } from "./BuildContactWithAssignedAccount.vue?vue&type=template&id=56df3d93&scoped=true"
import script from "./BuildContactWithAssignedAccount.vue?vue&type=script&lang=js"
export * from "./BuildContactWithAssignedAccount.vue?vue&type=script&lang=js"
import style0 from "./BuildContactWithAssignedAccount.vue?vue&type=style&index=0&id=56df3d93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df3d93",
  null
  
)

export default component.exports